import { Navigate, useLocation } from "react-router-dom";
import { ScanEye } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="text-center space-y-3">
          <div className="w-10 h-10 rounded-sm bg-brand-primary/10 border border-brand-primary/30 flex items-center justify-center mx-auto">
            <ScanEye className="w-5 h-5 text-brand-primary animate-pulse" />
          </div>
          <p className="text-sm font-mono text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
